import { css } from 'lit';

export const styles = [
  css`
    :host {
      --default-rem-px-count: 16;
      --column-gap: calc(32rem / var(--default-rem-px-count));
    }

    .header {
      padding-bottom: calc(42rem / var(--default-rem-px-count));
    }

    h1 {
      font-size: calc(32rem / var(--default-rem-px-count));
      font-weight: 500;
      letter-spacing: -1.12;
      line-height: calc(40rem / var(--default-rem-px-count));
    }

    h4 {
      font-size: calc(18rem / var(--default-rem-px-count));
      font-weight: 400;
      letter-spacing: -0.54;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    .page-wrapper {
      margin: 0 auto;
      max-width: 1440px;
      padding: 2rem 1rem;
      display: flex;
      flex-direction: column;
    }

    .form-wrapper {
      display: flex;
      flex-direction: column;
    }

    form {
      display: flex;
      flex-direction: column;
      max-width: calc(670rem / var(--default-rem-px-count));
    }

    .input-row {
      display: flex;
      flex-direction: column;
      column-gap: var(--column-gap);
      row-gap: calc(20rem / var(--default-rem-px-count));
      padding-bottom: calc(21rem / var(--default-rem-px-count));
    }

    .input-wrapper {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 0;
    }

    .reference-img-wrapper {
      margin-top: calc(20rem / var(--default-rem-px-count));
      max-width: 400px;
    }

    /* Sized by the image itself: a configured panel is a tall 1:2 and would
       otherwise be squashed into the photo-shaped box. */
    .reference-img-wrapper img {
      display: block;
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: calc(600rem / var(--default-rem-px-count));
      border: 1px solid #f0f0f0;
    }

    #uploads-wrapper {
      padding-bottom: calc(42rem / var(--default-rem-px-count));
    }

    .upload-trigger {
      display: flex;
      cursor: pointer;
      width: fit-content;
      align-items: center;
    }

    .upload-trigger img {
      padding-right: calc(14rem / var(--default-rem-px-count));
    }

    .upload-trigger p {
      font-size: 16px;
      letter-spacing: -0.24px;
      line-height: 24px;
      color: #222222;
      width: fit-content;
    }

    .upload-trigger:focus-within {
      outline: 2px solid #222222;
      outline-offset: 2px;
    }

    .fine-print {
      font-size: calc(12rem / var(--default-rem-px-count));
    }

    #selectedFiles span {
      display: flex;
      flex-direction: row;
      align-items: baseline;
    }

    #selectedFiles span > p {
      margin-bottom: 0;
    }

    .remove-file {
      font-size: calc(10rem / var(--default-rem-px-count));
      margin-left: calc(10rem / var(--default-rem-px-count));
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      color: inherit;
      text-decoration: underline;
      font-family: inherit;
    }

    .remove-file:focus-visible {
      outline: 2px solid #222222;
      outline-offset: 2px;
    }

    .validation-prompt {
      color: #d0021b;
    }

    .visually-hidden-submit {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .cta-btn {
      width: 50%;
    }

    .success-wrapper {
      display: flex;
      flex-direction: row;
      max-width: calc(670rem / var(--default-rem-px-count));
      column-gap: var(--column-gap);
    }

    .success-cta-btn {
      min-width: calc((100% - (2 * var(--column-gap))) / 3);
    }

    @media (min-width: 600px) {
      .page-wrapper {
        padding: 3rem 2rem;
      }

      .form-wrapper {
        gap: calc(40rem / var(--default-rem-px-count));
      }

      .reference-img-wrapper {
        margin-top: 0;
      }

      .input-row {
        flex-direction: row;
        column-gap: calc(32rem / var(--default-rem-px-count));
        padding-bottom: calc(21rem / var(--default-rem-px-count));
        row-gap: 0;
      }

      .cta-btn {
        width: calc((100% - (2 * var(--column-gap))) / 3);
      }
    }

    @media (min-width: 1024px) {
      .form-wrapper {
        flex-direction: row;
        gap: calc(120rem / var(--default-rem-px-count));
      }
    }
  `,
];
